module.exports = __webpack_public_path__ + "img/marked.5ab78f1c.svg";